import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import { Field, Form, Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../store/reducers';
import { firstLetterUpperCase } from '../../../helpers';
import TextInput from '../../Form/TextInput/TextInput';
import Heading from '../../Typography/Heading/Heading';
import Button from '../../Button/Button';
import Loader from '../../Loader/Loader';
import Modal from '../../Modal/Modal';
import styles from './GuildModal.module.scss';
import DropdownMenuElemToggle from '../../DropDownMenu/DropdownMenuElemToggle/DropdownMenuElemToggle';
import { GuildActionsName } from '../../../store/reducers/Guild/guildType';
import { clearData } from '../../../store/reducers/Guild/slice';
import { banUser } from '../../../store/reducers/Guild/guildRequest';
import { useBanGuildValidationSchema } from '../../../validations/banUser';
var IUserActionsName;
(function (IUserActionsName) {
    IUserActionsName["TEMPORARY"] = "temporary";
    IUserActionsName["PERMANENTLY"] = "permanently";
})(IUserActionsName || (IUserActionsName = {}));
const GuildModal = ({ title = true, userData, guildId, closeModal }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const { error, pending, isDataSent } = useAppSelector((state) => state.guild);
    const [status, setStatus] = useState(false);
    const [statusName, setStatusName] = useState(IUserActionsName.TEMPORARY);
    const banGuildValidationSchema = useBanGuildValidationSchema();
    useEffect(() => {
        if (!error && isDataSent.includes(GuildActionsName.BAN_USER)) {
            closeModal();
            dispatch(clearData(GuildActionsName.BAN_USER));
        }
    }, [error, isDataSent, dispatch, closeModal, pending]);
    const sendData = (values) => {
        const checkAction = {
            [IUserActionsName.TEMPORARY]: () => dispatch(banUser({
                guildId: guildId,
                data: {
                    id: userData === null || userData === void 0 ? void 0 : userData.member.id,
                    reason: values.reason,
                    period: values.numberOfDays
                }
            })),
            [IUserActionsName.PERMANENTLY]: () => dispatch(banUser({
                guildId: guildId,
                data: { id: userData === null || userData === void 0 ? void 0 : userData.member.id, reason: values.reason }
            }))
        };
        checkAction[statusName]();
    };
    useEffect(() => {
        !status
            ? setStatusName(IUserActionsName.TEMPORARY)
            : setStatusName(IUserActionsName.PERMANENTLY);
    }, [status]);
    return (_jsxs(Modal, Object.assign({ background: true, className: styles.element, closeModal: closeModal }, { children: [_jsx(Heading, { title: title }), _jsx(DropdownMenuElemToggle, { className: styles.status, label: firstLetterUpperCase(statusName), onClick: () => setStatus(!status), checked: status }), _jsx(Formik, Object.assign({ initialValues: {
                    reason: '',
                    numberOfDays: 60
                }, validationSchema: banGuildValidationSchema, onSubmit: (values) => {
                    sendData(values);
                } }, { children: ({ handleChange, handleBlur, values, handleSubmit }) => (_jsxs(Form, Object.assign({ className: styles.form, onSubmit: handleSubmit }, { children: [statusName === IUserActionsName.TEMPORARY ? (_jsxs(_Fragment, { children: [_jsx(Field, { label: t('reason'), className: "w-100", type: "text", onChange: handleChange, onBlur: handleBlur, name: "reason", id: "reason", value: values.reason, component: TextInput }), _jsx(Field, { label: t('number_of_days'), className: "w-100", type: "text", onChange: handleChange, onBlur: handleBlur, name: "numberOfDays", id: "numberOfDays", defaultValue: values.numberOfDays, value: values.numberOfDays, component: TextInput })] })) : (_jsx(_Fragment, { children: _jsx(Field, { label: t('reason'), className: "w-100", type: "text", onChange: handleChange, onBlur: handleBlur, name: "reason", id: "reason", value: values.reason, component: TextInput }) })), pending.includes(GuildActionsName.BAN_USER) ? (_jsx(Button, { className: cn('w-100'), height: 'sm', size: '100', type: 'submit', text: "", icon: _jsx(Loader, { isTransparent: true }) })) : (_jsx(Button, { className: cn(styles.button, 'w-100'), height: 'sm', size: '100', type: 'submit', text: t('ban_user') }))] }))) }))] })));
};
export default GuildModal;
